
'use strict'

class OurBeginnings{
    constructor(){
        
    }
}

export default OurBeginnings;